import type { ProgressWidgetId } from "@heraion/shared";

import type { TFn } from "../i18nTypes";

// PG-57: what the UI needs per Progress widget, twin of
// Home/homeWidgetCatalog.ts: the wide-layout column and the name the config
// sheet and a collapsed card show. The ids and the default layout
// live in @heraion/shared (progressLayout.ts). A panel Home also offers keeps
// the one name Home gives it; the Progress-only widgets name themselves.

/** Wide layout, twin of HOME_WIDGET_COLUMN: the wide charts in MAIN, the
 *  compact lists and counts in the RAIL. Order inside each column follows
 *  the athlete's one order list. */
export const PROGRESS_WIDGET_COLUMN: Record<ProgressWidgetId, "main" | "rail"> = {
  coverage: "main",
  e1rmTrends: "main",
  repsAtLoad: "main",
  movementBalance: "rail",
  painVolume: "rail",
  rhythm: "rail",
  tagVolume: "main",
  intensityHeatmap: "main",
  exerciseFrequency: "rail",
  prTimeline: "rail",
  weekStreak: "rail",
};

const KEY: Record<ProgressWidgetId, string> = {
  coverage: "mobile.home.config.widget.coverage",
  e1rmTrends: "mobile.home.config.widget.e1rmTrends",
  repsAtLoad: "mobile.home.config.widget.repsAtLoad",
  movementBalance: "mobile.home.config.widget.movementBalance",
  painVolume: "mobile.home.config.widget.painVolume",
  rhythm: "mobile.progress.config.widget.rhythm",
  tagVolume: "mobile.progress.tagVolumeTitle",
  intensityHeatmap: "mobile.home.config.widget.intensityHeatmap",
  exerciseFrequency: "mobile.home.config.widget.exerciseFrequency",
  prTimeline: "mobile.progress.config.widget.prTimeline",
  weekStreak: "mobile.progress.config.widget.weekStreak",
};

const LABEL: Record<ProgressWidgetId, string> = {
  coverage: "Muscle coverage",
  e1rmTrends: "E1RM trends",
  repsAtLoad: "Reps at load",
  movementBalance: "Movement balance",
  painVolume: "Pain × volume",
  rhythm: "Training rhythm",
  tagVolume: "Volume by tag",
  intensityHeatmap: "Intensity heatmap",
  exerciseFrequency: "Stalest exercises",
  prTimeline: "PR timeline",
  weekStreak: "Consistency streak",
};

export function progressWidgetLabel(t: TFn, id: ProgressWidgetId): string {
  return t(KEY[id], { defaultValue: LABEL[id] });
}
